import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '../layout/index.vue'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Layout,
    redirect: '/dataOverview',
     meta: { requiresAuth: true },
    children: [
      {
        path:'/dataOverview',
        name:'dataOverview',
        component: () => import('../views/dataOverview/dataOverview.vue')
      },
      {
        path:'/list',
        name:'list',
        component: () => import('../views/list/list.vue')
      },
      {
        path:'/payUserList',
        name:'payUserList',
        component: () => import('../views/payUserList/payUserList.vue')
      },
      // {
      //   path:'/collectionList',
      //   name:'collectionList',
      //   component: () => import('../views/collectionList/collectionList.vue')
      // },
      // {
      //   path:'/fleetCarList',
      //   name:'fleetCarList',
      //   component: () => import('../views/fleetCarList/fleetCarList.vue')
      // },
      // {
      //   path:'/orderList',
      //   name:'orderList',
      //   component: () => import('../views/orderList/orderList.vue')
      // },
      // {
      //   path:'/voucherList',
      //   name:'voucherList',
      //   component: () => import('../views/voucherList/vouchierList.vue')
      // }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  {
    path: "/:catchAll(.*)", // 不识别的path自动匹配404
    redirect: '/404',
  },
  {
    path: '/404',
    name: 'NotFound',
    component: ()=> import('../views/error/404.vue')
  }
]
function isLoggedIn() {
  // 例如，检查 localStorage 中是否存在 token
  return !!localStorage.getItem('viUserDetailBaiXiong')
}
const router = createRouter({
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  console.log('isLoggedIn',isLoggedIn())
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!isLoggedIn()) {
        // 如果用户未登录，则重定向到登录页面
        next({
          name: 'login'
        })
      } else {
        next() // 用户已登录，允许访问
      }
    } else {
      next()
    }
})



export default router
